<template>
  <div
    class="social-networks__content"
  >
    <ZTitle
      class="social-networks__title"
      size="small"
    >
      Compartilhe o gabarito com seus amigos
    </ZTitle>
    <ZText
     class="social-networks__text"
    >
      Ajude um amigo a conferir como foi nas provas do enem:
    </ZText>
    <div>
      <VLazyImage
        class="social-networks__image"
        width="40"
        height="40"
        :src="icons.facebookIcon"
        @click="shareFacebook"
        alt="facebook"
      />
      <VLazyImage
        class="social-networks__image"
        width="40"
        height="40"
        :src="icons.whatsappIcon"
        @click="shareWhatsapp"
        alt="whatsapp"
      />
      <VLazyImage
        class="social-networks__image"
        width="40"
        height="40"
        :src="icons.twitterIcon"
        @click="shareTwitter"
        alt="twitter"
      />
    </div>
  </div>
</template>

<script>
import { ZText, ZTitle } from '@quero/zilla-vue';
import facebookIcon from '~/assets/images/icons/social-networks/facebook.png';
import twitterIcon from '~/assets/images/icons/social-networks/twitter.png';
import whatsappIcon from '~/assets/images/icons/social-networks/whatsapp.png';
import ShareMedia from '~/mixins/share-media';
import VLazyImage from "v-lazy-image";

export default {
  components: {
    ZText,
    ZTitle,
    VLazyImage,
  },
  props: {
    whatsapp: {
      type: Object,
      default: {
        description: 'Insira uma descrição',
      },
      url: String,
    },
    facebook: {
      type: Object,
      default: {
        title: 'Insira um titulo',
        description: 'Insira uma descrição',
      },
      url: String,
    },
    twitter: {
      type: Object,
      default: {
        title: 'Insira um titulo',
        description: 'Insira uma descrição',
        hashtags: 'Insira as hastags'
      },
      url: String,
    },
  },
  mixins: [
    ShareMedia,
  ],
  methods: {
    shareFacebook() {
      this.shareOnFacebook(this.facebook.title, this.facebook.description, this.facebook.url)
    },
    shareTwitter() {
      this.shareOnTwitter(this.twitter.title, this.twitter.url, this.twitter.hashtags)
    },
    shareWhatsapp() {
      this.shareOnWhatsapp(this.whatsapp.description, this.whatsapp.url);
    }
  },
  data() {
    return {
      icons: {
        facebookIcon,
        twitterIcon,
        whatsappIcon,
      },
    };
  },
}
</script>

<style lang="scss" scoped>
  @import "@quero/zilla-core/src/utils/variables.scss";

  .social-networks__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: $space-xxl;
    margin-top: $space-l;
    width: 284px;

    @media (min-width: $screen-desktop) {
      display: flex;
      margin-left: $space-xxl;
      width: 380px;
    }
  }

  .social-networks__title {
    margin-top: rem(16);
    @media (min-width: $screen-sm-min) {
      margin-top: 0;
    };
  }

  .social-networks__text {
    margin-bottom: $space-l;
    margin-top: $space-s;
  }

  .social-networks__image {
    cursor: pointer;
    margin-right: $space-s;
  }
</style>
